import React from 'react';
import classNames from 'classnames';
import { withStyles } from './../../../../themes/default';

const styles = theme => ({
  root: {
    padding: theme.spacing.unit * 2,
    background: theme.palette.grey[50],
    border: `1px solid ${ theme.palette.grey[200] }`,
    borderRadius: theme.spacing.unit / 2,
    position: 'relative'
  }
});

const Boxed = ({children, classes, ...rest}) => {

  return (
    <div className={ classNames(classes.root) }>
      { children }
    </div>
  )

}

export default withStyles(styles)(Boxed);
